import { BaseBonusCongratulationsPopup } from './BaseBonusCongratulationsPopup';
import { gameConfig } from '../../../core/configs';

class BonusCongratulationsWebPopup extends BaseBonusCongratulationsPopup {
  execute({ root }) {
    super.execute({ root });
    return this.loadResource([]).then(() => {
      const container = this.getPopup({
        sizes: {
          width: 1050,
          parentWidth: gameConfig.width,
          parentHeight: gameConfig.height,
          scale: 1.4,
          percent: 18,
        },
      });
      root.addChild(container);
    });
  }
}

export const bonusCongratulationsWebPopup = new BonusCongratulationsWebPopup();